function isNil(value) {
    return value == null;
}

export { isNil as default };
